import React, { ReactElement } from 'react';

import { AsaphButton } from '@/components/shared/Button';
import { BottomActionLayout } from '@/components/shared/BottomActionLayout/BottomActionLayout';
import { FilterChipList } from '@/components/shared/FilterChipList';
import { SearchInput } from '@/components/shared/Inputs/SearchInput';
import { TeamMemberListProps } from '@/components/TeamMemberList';
import { sentenceCase } from '@/helpers/changeCase';
import styles from './TeamMemberLayout.module.scss';

interface TeamMemberLayoutProps {
	membersList: ReactElement<TeamMemberListProps>;
	onInviteClick: () => void;
	teamInfoLoading: boolean;
	searchQuery: string;
	onSearchChange: (q: string) => void;
	activeSkill: string | null;
	onSkillChange: (s: string | null) => void;
	uniqueSkills: string[];
	adminCount: number;
}

export const TeamMemberLayout: React.FC<TeamMemberLayoutProps> = ({
	membersList,
	onInviteClick,
	teamInfoLoading,
	searchQuery,
	onSearchChange,
	activeSkill,
	onSkillChange,
	uniqueSkills,
	adminCount,
}) => {
	return (
		<BottomActionLayout
			noPadding
			actionContentClassName={styles['layout__action-bg']}
			actionContent={
				<div className={styles['action-stack']}>
					{adminCount >= 1 && (
						<div className={styles['capacity-banner']}>
							{adminCount} of 1 admin slots on your current plan.
						</div>
					)}
					<AsaphButton
						color="blue"
						label="Add people"
						onClick={onInviteClick}
						disabled={teamInfoLoading}
						fullWidth
					/>
				</div>
			}
		>
			<div className={styles['layout']}>
				<div className={styles['layout__search']}>
					<SearchInput
						id="team-member-search"
						name="team-member-search"
						value={searchQuery}
						onChange={(e) => onSearchChange(e.target.value)}
						clearSearchQuery={() => onSearchChange('')}
						placeholder="Search people"
						fullWidth
					/>
				</div>
				<div className={styles['layout__chips']}>
					<FilterChipList
						options={[
							{ label: 'Admin', value: 'admin' },
							...uniqueSkills.map((skill) => ({ label: sentenceCase(skill), value: skill })),
						]}
						value={activeSkill}
						onChange={onSkillChange}
						className={styles['layout__chip-list']}
					/>
				</div>
				<div className={styles['layout__panel']}>
					{membersList}
				</div>
			</div>
		</BottomActionLayout>
	);
};
